/**
 * This function creates a route for the installation farm context in the system-settings
 *
 * @param installationId
 * @param storageId
 * @param childStorageId
 * @param url
 * @returns a route for the installation context
 */
export const getFarmDetailsRoute = (
  installationId = ':installationId',
  storageId = ':storageId',
  childStorageId: string | number = ':childStorageId',
  url?: string
): string => {
  if (url) {
    return `${url}/properties/installation`
  }
  return `/installation/${installationId}/${storageId}/properties/installation/${childStorageId}`
}

export const getDetailsRoute = (installationId = ':installationId', storageId = ':storageId', url?: string): string => {
  if (url) {
    return `${url}/properties/installation/`
  }

  return `/installation/${installationId}/${storageId}/properties/installation`
}
